module.exports = __webpack_public_path__ + "static/media/network.e7c7827c.png";